/**
 * Página FAQ — Collapse con las preguntas frecuentes. La respuesta
 * es Markdown → soporta enlaces, listas, negritas, código. Filtro
 * por texto sobre pregunta + respuesta.
 */

import { useMemo, useState } from "react";
import { Collapse, Empty, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { PageHeader } from "@/components/common/PageHeader";
import { onboardingMarkdownComponents } from "./markdownComponents";
import { usePageTitle } from "@/hooks";
import { faqs } from "@/data/onboarding";

export const FAQPage: React.FC = () => {
  usePageTitle("FAQ — Onboarding");
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return faqs;
    return faqs.filter(
      (f) =>
        f.question.toLowerCase().includes(q) ||
        f.answer.toLowerCase().includes(q),
    );
  }, [query]);

  return (
    <>
      <PageHeader
        title="Preguntas frecuentes"
        subtitle="Respuestas rápidas a las consultas más habituales. Si tu duda no está aquí, plantéala al responsable del puesto y añádela después editando faq.json."
      />

      <Input
        allowClear
        prefix={<SearchOutlined />}
        placeholder="Buscar en preguntas y respuestas…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{ maxWidth: 480, marginBottom: 20 }}
      />

      {filtered.length === 0 ? (
        <Empty description="No hay preguntas que coincidan." />
      ) : (
        <Collapse
          accordion
          items={filtered.map((f) => ({
            key: f.id,
            label: f.question,
            children: (
              <div className="onboarding-markdown">
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={onboardingMarkdownComponents}
                >
                  {f.answer}
                </ReactMarkdown>
              </div>
            ),
          }))}
        />
      )}
    </>
  );
};
